import LayoutWrapper from './pages/LayoutWrapper'
import { RouteNames } from 'constants/routeNames'

const routes = {
  routes: [
    {
      key: 'search',
      type: 'public',
      path: `/${RouteNames.SEARCH}`,
      component: LayoutWrapper,
      exact: true,
    },
    {
      key: 'search_content',
      type: 'public',
      path: `/${RouteNames.SEARCH}/:id`,
      component: LayoutWrapper,
      exact: true,
    },
  ],
}

export default routes
